import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';

const ElectronicSignature = ({ nextStep, prevStep, handleSubmit, active, processing, secondary }) => {

  const [isSelected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondary]);

  const toggleSelection = () => {
    setSelected(!isSelected);
  };

  const handleNext = () => {
      if (!isSelected) {
          toast.error('Please sign MYRA Client Account Agreement and the Portfolio Line of Credit Agreement through Electronic Signature.');
          return;
      }

      let payload = {};
      if(isSelected) {
          payload = {
              electronic_signature: "true"
          };
      }

    nextStep(payload);
  };

  const handleBack = () => {
    prevStep();
  };

  return (
    <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
      <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
        <div className="back-btn">
          <Button color="link" onClick={handleBack}>back</Button>
        </div>
        <div className="form-header mt-md-3 mt-0">
          <h2>ELECTRONIC SIGNATURE</h2>
          <span>Please check the required regulatory disclosures</span>
        </div>
        <div className="account-info-container">
          <FormGroup check className="left-check-minus">
            <Label check>
              <Input type="checkbox" onChange={toggleSelection} />
              You are electronically signing the MYRA <a href="#/">Client Account Agreement</a> and
              the Portfolio <a href="#/">Line of Credit Agreement</a>.
              <br /><br />
              You also certify that you are not subject to IRS backup withholding,
              and acknowledge our <a href="#/">Margin Handbook</a>, <a href="#/">Form ADV Part 2</a>,
               Cash <a href="#/">Sweep Disclosure Statement</a>.
            </Label>
          </FormGroup>
        </div>
        <div className="button_wrapper">
          <button className="custom-btn-primary" type="submit" disabled={processing}>
            SUBMIT {processing && <FontAwesomeIcon icon={faSpinner} spin />}
          </button>
        </div>
      </Form>
    </div>
  )
};

export default reduxForm({
  form: 'ElectronicSignatureForm',
})(ElectronicSignature);
